/**
 * @fileoverview
 * This context is intended to be used only by RTE's such as TinyMCE.
 *
 * TinyMCE needs to identify which floating elements belong to the editor to prevent
 * focus loss when users interact with dropdowns, tooltips, and other components.
 * This context provides the `data-tinymce-floating-element` attribute to mark these elements.
 * See https://github.com/HubSpotEngineering/structured-content/issues/702 and https://github.com/HubSpotEngineering/structured-content/issues/712 for more details.
 */

import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_CONTEXT_VALUE_FOR_TINYMCE = {
  'data-tinymce-floating-element': 'true'
};
const DEFAULT_CONTEXT_VALUE = {};
const RTEContext = /*#__PURE__*/createContext(DEFAULT_CONTEXT_VALUE);
const {
  Consumer,
  Provider
} = RTEContext;
export { Consumer as RTEContextConsumer };
export const RTEContextProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Provider, {
    value: DEFAULT_CONTEXT_VALUE_FOR_TINYMCE,
    children: children
  });
};
export const useRTEContext = () => {
  const context = useContext(RTEContext);
  return context;
};